import { ActiveIngredientComposition } from '@dreryk/drerykweb-medicine-api';

export const formatMedicineActiveIngredients = (activeIngredients: ActiveIngredientComposition[]): string | null => {
   if (activeIngredients.length === 0) {
      return null;
   }

   return activeIngredients
      .map((activeIngredient) => {
         const amount = `${activeIngredient.nominalStrength ?? ''}${activeIngredient.unitName ?? ''}`;
         return `${activeIngredient.name}${amount ? ` ${amount}` : ''}`;
      })
      .join(', ');
};
